ixModuleRouting("impactx.dashboard", {
    "/dashboard": {
        templateUrl: "modules/dashboard/templates/dashboard.tmpl.html",
        controller: "DashboardCtrl",
        controllerAs: "dashboardCtrl",
        process: "Dashboard",
        workspace: "shop",
    },
    "/editdashboard/:comId": {
        template: "<ixa-edit-dashboard></ixa-edit-dashboard>",
        process: "EditDashboard",
        workspace: "admin",
    },
    "/editdashboard": {
        template: "<ixa-edit-dashboard></ixa-edit-dashboard>",
        process: "EditGlobalDashboard",
        workspace: "system",
    },
});
